<app-fleet-page-header
  (clearSearch)="model.setSearch('')"
  (searchChanged)="model.setSearch($event)"
  (sortChanged)="model.setOrder($event)"
  [columns]="state.columns$ | async"
  [counter]="(state.count$ | async) ?? 0"
  [defaultSortOrder]="state.defaultSortOrder$ | async"
  [search]="state.search$ | async"
  [showActionsSpacer]="false"
  [showCounter]="true"
  [showExport]="false"
  [showMobileCounterIcon]="true"
  [showMobileMenuButton]="false"
  [showPdfExportOption]="false"
  [showSearch]="true"
  [sortOrder]="state.gridSortOrder$ | async"
  [templates]="{ actionButtons, countIcon }"
  [titleText]="'users.title' | translate"
></app-fleet-page-header>

<ng-template #countIcon>
  <app-icon-users [height]="22" [width]="22"></app-icon-users>
</ng-template>

<ng-template #actionButtons let-isMobile="isMobile">
  <div class="vertical-spacer"></div>
  <p-button
    (click)="addUserDialog.open()"
    [appCheckAccess]="[Resource.User, Action.Create]"
    [icon]="isMobile ? 'pi' : ''"
    [severity]="'primary'"
    class="h--40 p--16 text-14 fw-500"
  >
    <app-icon-plus [height]="20" [width]="20" class="icon"></app-icon-plus>
    @if (!isMobile) {
      {{ 'users.add-btn' | translate }}
    }
  </p-button>
</ng-template>

<app-users-grid
  [displayColumns]="['user', 'auditId', 'role', 'lastActivity', 'mfa', 'actions']"
></app-users-grid>

@if (state.selectedItem$ | async; as userData) {
  <app-edit-user-dialog
    (closed)="model.unselect()"
    [country]="TYPES.CountryCodes.UnitedStates"
    [mode]="TYPES.UserFormMode.TI"
    [opened]="true"
    [user]="userData"
    [usernamePrefix]="''"
  ></app-edit-user-dialog>
}

<app-add-user-dialog
  #addUserDialog
  [country]="TYPES.CountryCodes.UnitedStates"
  [mode]="TYPES.UserFormMode.TI"
  [usernamePrefix]="''"
></app-add-user-dialog>
